module.exports = __webpack_public_path__ + "img/BUY.37b837c8.svg";